import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import '../assets/style/GeoPxlLanding.css';

import { getAppUrl } from '../App';

const GeoPxlLanding = ({ t, language }) => {
  const features = t('about.features', { returnObjects: true }) || [];
  const steps = t('workflow.steps', { returnObjects: true }) || [];
  const projects = t('projects.items', { returnObjects: true }) || [];

  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.scrollY;

      setIsScrolled((prev) => {
        if (prev && currentScroll <= 10) return false;
        if (!prev && currentScroll > 20) return true;
        return prev;
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="gp-wrapper">
      <header className={`gp-header ${isScrolled ? 'gp-scrolled' : ''}`}>
        <div className="gp-container gp-nav">
          <img src="/logo_trans.png" alt="GeoPxl logo" className="gp-logo" />
          <div className="gp-nav-buttons">
            <div className="gp-lang-wrapper">
              <select 
                name="language" 
                id="language" 
                className="gp-language-select" 
                value={language.active} 
                onChange={(e) => language.set(e.target.value)}
              >
                {language.list.map((lang) => (
                  <option key={lang} value={lang}>
                    {lang.toUpperCase()}
                  </option>
                ))}
              </select>
            </div>
            <a href={getAppUrl()} className="gp-btn gp-btn-login">{t('header.login')}</a>
            <a href={getAppUrl() + "/createuser"} className="gp-btn gp-btn-signup">{t('header.register')}</a>
          </div>
        </div>
      </header>

      <section className="gp-hero">
        <div className="gp-container gp-hero-grid">
          <div className="gp-hero-content">
            <span className="gp-eyebrow">{t('hero.eyebrow')}</span>
            <h1 className="gp-hero-title">{t('hero.title')}</h1>
            <p className="gp-hero-desc">{t('hero.description')}</p>
            <div className="gp-hero-actions">
              <a href={getAppUrl() + "/createuser"} className="gp-btn gp-btn-signup">{t('hero.cta_start')}</a>
              <a href={getAppUrl()} className="gp-btn gp-btn-login">{t('hero.cta_login')}</a>
            </div>
            <div className="gp-hero-note">{t('hero.note')}</div>
          </div>
          <div className="gp-hero-visual">
            <div>
              <img src="/img/GeoPxlLanding/tomorrowland_square.jpg" alt="3D site visual" />
            </div>
          </div>
        </div>
      </section>

      <section className="gp-section gp-bg-white">
        <div className="gp-container">
          <h2 className="gp-section-title">{t('about.title')}</h2>
          <p className="gp-section-lead">{t('about.lead')}</p>
          <div className="gp-grid-3">
            {features.map((f) => (
              <div key={f.id} className="gp-card">
                <h3 className="gp-card-title">{f.title}</h3>
                <p className="gp-card-text">{f.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="gp-section gp-bg-alt">
        <div className="gp-container">
          <h2 className="gp-section-title">{t('workflow.title')}</h2>
          <p className="gp-section-lead">{t('workflow.lead')}</p>
          <div className="gp-workflow-grid">
            {steps.map((s) => (
              <div key={s.num} className="gp-card">
                <div className="gp-step-number">{s.num}</div>
                <strong className="gp-step-label">{s.title}</strong>
                <p className="gp-card-text">{s.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="gp-section gp-bg-white">
        <div className="gp-container">
          <h2 className="gp-section-title">{t('projects.title')}</h2>
          <div className="gp-grid-3">
            {projects.map((p) => (
              <div key={p.id} className="gp-card gp-project-card">
                <img src={"/img/GeoPxlLanding/" + p.image} alt={p.title} className="gp-project-img" />
                <div className="gp-project-body">
                  <h3 className="gp-card-title">{p.title}</h3>
                  <p className="gp-card-text">{p.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="gp-container">
        <div className="gp-cta-block">
          <h2 className="gp-cta-title">{t('cta_footer.title')}</h2>
          <p className="gp-cta-text">{t('cta_footer.text')}</p>
          <div className="gp-hero-actions gp-center">
            <a href={getAppUrl() + "/createuser"} className="gp-btn gp-btn-signup">{t('cta_footer.btn_reg')}</a>
            <a href={getAppUrl()} className="gp-btn gp-btn-login gp-btn-outline-white">{t('cta_footer.btn_login')}</a>
            <a href="mailto:geopxl@ravco.be" className="gp-btn gp-btn-contact">{t('cta_footer.btn_contact')}</a>
          </div>
        </div>
      </div>

      <footer className="gp-footer">
        <div className="gp-container">{t('footer.copy')}</div>
      </footer>
    </div>
  );
};

export default withTranslation("GeoPxlLanding")(GeoPxlLanding);